import blueGrey from "@material-ui/core/colors/blueGrey";

export const headerColor = blueGrey[900];
export const mainContentColor = blueGrey[800];
export const subContentColor = blueGrey[600];
export const modalContentColor = blueGrey[600];
export const modalSelectedColor = blueGrey[300];
export const modalMainContentColor = blueGrey[800];
export const modalSubContentColor = blueGrey[400];
export const modalArtSkilCardColor = blueGrey[100];
export const modalTextColor = blueGrey[200];
export const modalStressTextColor = blueGrey[50];

export const textColor = blueGrey[50];
